import React, { useState, useEffect, Suspense } from 'react'
import { useParams } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import LoadingBar from 'react-top-loading-bar'
import {Helmet} from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import VideoBox from '../Global/VideoBox';
import ImageBox from '../Global/ImageBox';
import EmptyContent from '../Global/EmptyContent';

import './Premium.css'
import styles from '../../App.module.css';
import classes from './Premium.module.css'

function Premium() {
    const [progress, setProgress] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [media, setMedia] = useState([]);

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        axios.post(`${process.env.REACT_APP_API_URL}/api/premium.php`, null, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        }).then(res => {
            // console.log(res.data);
            setMedia(res.data)
        }).catch(err => {
            console.log(err);
        })
    }, [])

    return (
        <>
            <Helmet>
                <title>Premium Contents - Wesharez</title>
                <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
                <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
            </Helmet>
            <LoadingBar
                color='#f11946'
                progress={progress}
                onLoaderFinished={() => setProgress(0)}
            />
            <Header />
            <div className={styles.main_body}>
                <Suspense fallback="<div>Please wait...</div>">
                    <Sidebar active="premium" />
                </Suspense>
                <Suspense fallback="<div>Please wait...</div>">
                    <div className={styles.main_content + ` main-content`}>
                        <ins className='adsbygoogle p-4 pb-0'
                            style={{ display: 'block' }}
                            data-ad-client='ca-pub-8126596259429304'
                            data-ad-slot='5153011292'
                            data-ad-format='auto'
                        />
                        <div className={`${classes.premium_component} premium_component p-4`}>
                            <div className={classes.sec_name}>
                                <h3>Premium Contents</h3>
                            </div>
                            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                                <TabList>
                                    <Tab><i className="fa-solid fa-file-video"></i> Premium Videos</Tab>
                                    <Tab><i className="fa-solid fa-file-image"></i> Premium Images</Tab>
                                </TabList>
                                <TabPanel>
                                    <div className="row">
                                        {
                                            media.videos && media.videos.map ? media.videos.map((video, index) => {
                                                return (
                                                    <div key={index} className="col-lg-3 col-sm-6">
                                                        {
                                                            VideoBox(video)
                                                        }
                                                    </div>
                                                )
                                            })
                                            : <EmptyContent />
                                        }
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="row">
                                        {
                                            media.images && media.images.map ? media.images.map((image, index) => {
                                                return(
                                                    <div className={`${styles.item} col-lg-3 col-md-4 col-6 col-sm`} key={index}>
                                                        {
                                                            ImageBox(image)
                                                        }
                                                    </div>
                                                )
                                            })
                                            : <EmptyContent />
                                        }
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                        <Footer />
                    </div>
                </Suspense>
            </div>
        </>
    )
}

export default Premium